import { render, staticRenderFns } from "./SmoothHeight.vue?vue&type=template&id=0ed15a34&scoped=true"
import script from "./SmoothHeight.vue?vue&type=script&lang=js"
export * from "./SmoothHeight.vue?vue&type=script&lang=js"
import style0 from "./SmoothHeight.vue?vue&type=style&index=0&id=0ed15a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed15a34",
  null
  
)

export default component.exports